import type { MapTheme } from "../engine";
import { EngineInvariantError } from "../errors";
import { plainColorAt } from "./plainTerrainColor";

function solidTileSvg(color: string): string {
  return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56 56" width="56" height="56">
  <rect width="56" height="56" fill="${color}"/>
</svg>`;
}

function grassSolidTile({ x, y, theme }: { x: number; y: number; theme: MapTheme }): string {
  return solidTileSvg(plainColorAt({ x, y, theme }));
}

export function svgDataUrl(svg: string): string {
  return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
}

export function terrainSvg({
  kind,
  x,
  y,
  theme,
}: {
  kind: "plain";
  x: number;
  y: number;
  theme?: MapTheme;
}): string {
  if (kind !== "plain") {
    throw new EngineInvariantError(`terrainSvg only supports plain tiles, got ${String(kind)}`);
  }
  return grassSolidTile({ x, y, theme: theme ?? "classic" });
}
